import { styled } from "@mui/system";
import { Box } from "@mui/material";

const VerificationCodeStyles = styled(Box)(({ theme }) => ({
  "& .rememberMeContainer": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: theme.spacing(0.1),
    "& .customCheckbox.Mui-checked": {
      color: theme.palette.primary.main,
    },
  },
  "& .VerificationTitle": {
    fontSize: theme.typography.pxToRem(30),
    fontWeight: "bold",
    paddingTop: theme.spacing(4),
  },
}));

export default VerificationCodeStyles;
